import { render, staticRenderFns } from "./ReserveFundDivider.vue?vue&type=template&id=5534e0a6&"
import script from "./ReserveFundDivider.vue?vue&type=script&lang=js&"
export * from "./ReserveFundDivider.vue?vue&type=script&lang=js&"
import style0 from "./ReserveFundDivider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports